import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import HomeAdCarousel from "./HomeAdCarousel";
import * as auctionActions from "../redux/actions/adAuctionActions";
import * as adListActions from "../redux/actions/adListActions";
import * as adActions from "../redux/actions/adActions";

function mergeAuctionDonation(auctionList, donationList) {
  const seen = new Set();
  const merged = [];

  [...(auctionList || []), ...(donationList || [])].forEach((item) => {
    if (!item?.Id || seen.has(item.Id)) return;
    seen.add(item.Id);
    merged.push(item);
  });

  return merged;
}

class HomeAuctionDonationCarousel extends React.Component {
  componentDidMount() {
    if (!this.props.token || !this.props.user_id) return;
    this.props.LoadAuction(this.props.user_id, this.props.token);
    this.props.LoadDonation(this.props.user_id, this.props.token);
  }

  render() {
    const { auctionList, donationList, loadingAuction, loadingDonation } = this.props;
    const adList = mergeAuctionDonation(auctionList, donationList);

    return (
      <HomeAdCarousel
        title={<Translate value="home_auction_donation_title" />}
        subtitle={<Translate value="home_auction_donation_subtitle" />}
        links={[
          {
            to: "/home/auction",
            label: I18n.t("auction"),
          },
          {
            to: "/home/donations",
            label: I18n.t("donations"),
          },
        ]}
        adList={adList}
        loading={loadingAuction || loadingDonation}
        onAdClick={this.props.SetAd}
        seeMoreTo="/home/auction"
      />
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    auctionList: reducer.adAuction.list,
    donationList: adListActions.selectCachedAdList(reducer, adListActions.AD_SOURCES.DONATION),
    loadingAuction: reducer.adAuction.loading && !reducer.adAuction.loaded,
    loadingDonation: adListActions.isAdListLoading(reducer, adListActions.AD_SOURCES.DONATION),
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadAuction: (user_id, token) =>
    dispatch(auctionActions.loadListAuction({ user_id, token })),
  LoadDonation: (user_id, token) =>
    dispatch(adListActions.loadListDonation({ user_id, token })),
  SetAd: (item) => dispatch(adActions.setAd({ item })),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeAuctionDonationCarousel);
